import React, { useEffect, useRef, useState, FC } from "react";
import { Button, message } from "antd";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from "@/components/YhFormBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { globalPrompt } from "@/components/message"
import { usePurchasePoDetailsModel } from "./purchasePoDetailsModel";
import { DetailType } from "@/types/ScmEnums";
import { useDictModel } from "../../../../base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import useGlobalModel, { transOptions, getFindItem } from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { formatNum } from "@/utils/utils";
import { itemService } from "@/views/base/item/itemService";

export const FormBox: FC<RouterParamType> = ({ id, mode, purchasePoDetails }) => {

    const { detailEditForm, detailAddForm, detailLookForm, detailAddList, detailDataSource, detailLookList, setDetailAddList, setDetailDataSource, updateAddFormVal, updatEditFormVal, getDetailEditOne, resetAddCatch, taxincluded, setTaxincluded, resetEditCatch } = usePurchasePoDetailsModel();
    const [more, setMore] = useState<boolean>(true);  //控制更多按钮
    const { selectedNavId, addNav, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const { getTreeSelectOne, getSelectedDictOne, getTreeNodeName } = useDictModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale, supplieAllList } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const typeForm = {
        add: detailAddForm,
        edit: detailEditForm,
        look: detailLookForm
    }
    useEffect(() => {
        if (!Object.keys(detailEditForm).length && mode == DetailType.edit) {
            getDetailEditOne(id, mode)
        }
        mode == DetailType.look && getDetailEditOne(id, mode)
    }, [id, mode])
    useEffect(() => {
        return () => {
            !findNav("3-1-1") && resetAddCatch(mode);
            !findNav("3-1-2") && resetEditCatch(mode);
        }
    }, [selectedNavId])
    const goSupplier = () => {
        replaceNav(
            selectedNavId,
            "13-1-1",
            {
                id: "", mode: "add", parentInfo: {
                    mode,
                    selectedNavId,
                    id
                }
            },
            true)
    }
    const onTaxChange = (value: string) => {
        setTaxincluded(!!!value ? true : false)
        let newDetailsList = mode == "add" ? detailAddList : detailDataSource;
        let { taxRateCode } = mode == "add" ? detailAddForm : detailEditForm;
        // console.log(taxRateCode)

        newDetailsList.forEach((item) => {
            item.taxPrice = !!!value ? formatNum(Number(item.price) * Number(taxRateCode)) : item.price
            item.amount = !!!value ? formatNum(Number(item.price) * Number(item.num) * Number(taxRateCode)) : formatNum(Number(item.price) * Number(item.num))
        })
        mode == "add" ? setDetailAddList(newDetailsList) : setDetailDataSource(newDetailsList)
    }
    const onTaxRateCodeChage = (value: string) => {    
        let newDetailsList = mode == "add" ? detailAddList : detailDataSource;
        let taxRateCode = value;
        newDetailsList.forEach((item) => {
            item.taxPrice = taxincluded ? formatNum(Number(item.price) * Number(taxRateCode)) : item.price
            item.amount = taxincluded ? formatNum(Number(item.price) * Number(item.num) * Number(taxRateCode)) : formatNum(Number(item.price) * Number(item.num))
        })
        mode == "add" ? setDetailAddList(newDetailsList) : setDetailDataSource(newDetailsList)
    }
    const baseFormItem: IYhFormItemsBox = {
        // title: "基础信息",
        title: Locale["Basic Info"],
        style: { padding: "18px 0 0 0", marginBottom: "15px" },
        contentClass: "pr-77",
        items: [
            {
                type: FormItemTypeEnum.Select,
                showSearch: true,
                fieldLabel: <span className="click-span" onClick={goSupplier}>{Locale["Supplier Name"]}</span>,
                fieldName: "supplierCode",
                options: transOptions(supplieAllList)
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系人",
                fieldLabel: Locale["Contact"],
                fieldName: "contact",
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "制单时间",
                fieldLabel: Locale["Creation Time"],
                disable: true,
                fieldName: "createTime",
            }, {
                type: FormItemTypeEnum.Select,
                // fieldLabel: "结算类型",
                fieldLabel: Locale["Payment Type"],
                fieldName: "payType",
                options: getSelectedDictOne(DictCodeEnmu.SETTLE_TYPE),
                rules: [{ required: true, message: "请选择结算类型" }]
            }, {
                type: FormItemTypeEnum.Select,
                // fieldLabel: "结算类型",
                fieldLabel: "是否含税",
                fieldName: "taxIncluded",
                onSelectChange: onTaxChange,
                options: [{ label: "是", value: 1 }, { label: "否", value: 0 }],
                rules: [{ required: true, message: "请选择是否含税" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "税率",
                fieldName: "taxRateCode",
                showSearch: true,
                allowClear: true,
                onSelectChange: onTaxRateCodeChage,
                // options: getSelectedDictOne(DictCodeEnmu.TAX).map(item => ({ ...item, value: item.label })),
                // disable:typeForm[mode].taxIncluded?true:false,
                options: getSelectedDictOne(DictCodeEnmu.TAX).map(item => ({ ...item, value: item.label })),
                rules: [{ required: true, message: "请选择税率" }],
            }, {
                type: FormItemTypeEnum.TreeSelect,
                // fieldLabel: "供应商类型",
                fieldLabel: Locale["Supplier Type"],
                fieldName: "supplierTypeCode",
                treeData: getTreeSelectOne(DictCodeEnmu.SUPPLIER_TYPE),
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系电话",
                fieldLabel: Locale["Contact Number"],
                fieldName: "phone",
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "备注",
                fieldLabel: Locale["Note"],
                fieldName: "note",
            }
        ]
    };

    const onChange = (changedValues: { [key: string]: any }) => {
        if (mode == DetailType.add) {
            updateAddFormVal(changedValues)
        } else if (mode == DetailType.edit) {
            updatEditFormVal(changedValues)
        }
    }

    const poFromConfig: IYhFormBox = {
        formRef: purchasePoDetails,
        labelCol: { span: 6 },
        labelAlign: "right",
        disabled: mode == DetailType.look,
        formValues: { ...typeForm[mode] },
        onChange,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...poFromConfig} />
    )
}